export default __webpack_public_path__ + "static/media/lubaantun5.28a15bd3.webp";